import {
  takeLatest,
  takeEvery
} from "redux-saga/effects";
import {
  schema
} from "normalizr";
import {
  authorizedRequest,
  downloadFile
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

import {
  defaultReturn,
  makePayload,
  makeReadPayload,
  makeWritePayload,
  generateDefaultActions,
  requestSaga,
  subKeySaga,
  fillDictionary
} from "../utils/helpers";

const initialState = {
  companyCreditRatings: []
};

export const GET_COMPANY_CREDIT_RATINGS = generateDefaultActions("GET_COMPANY_CREDIT_RATINGS");
export const getCompanyCreditRatings = payload => makePayload(GET_COMPANY_CREDIT_RATINGS.value, payload);

function* getCompanyCreditRatingsSaga(payload) {
  const url = "/companyCreditRatings";
  // const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_COMPANY_CREDIT_RATINGS, url);
}

export const UPDATE_COMPANY_CREDIT_RATINGS = generateDefaultActions("UPDATE_COMPANY_CREDIT_RATINGS");
export const updateCompanyCreditRatings = payload => makePayload(UPDATE_COMPANY_CREDIT_RATINGS.value, payload);
function* updateCompanyCreditRatingsSaga(payload) {
  const url = "/companyCreditRatings/";
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(UPDATE_COMPANY_CREDIT_RATINGS, url, "POST", payload);
}

export default function creditRatingsReducer(state = initialState, action) {
  const { type, payload, subKey } = action;

  switch (type) {
    case GET_COMPANY_CREDIT_RATINGS.success:
      return defaultReturn(state, payload.data, "companyCreditRatings");

    case UPDATE_COMPANY_CREDIT_RATINGS.success:
      ToastSuccess("Saved");

      return fillDictionary(state, payload, "companyCreditRatings", subKey);

    default:
      return state;
  }
}

export function* creditRatingsSaga() {
  yield takeLatest(GET_COMPANY_CREDIT_RATINGS.value, getCompanyCreditRatingsSaga);
  yield takeLatest(UPDATE_COMPANY_CREDIT_RATINGS.value, updateCompanyCreditRatingsSaga);
}
